import React from 'react'

function MobileApp() {
  return (
    <div>MobileApp</div>
  )
}

export default MobileApp